import { render, staticRenderFns } from "./FormWizard.vue?vue&type=template&id=08273418&"
import script from "./FormWizard.vue?vue&type=script&lang=js&"
export * from "./FormWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports